<script lang="ts">
  import { onMount } from 'svelte'
  import Divider from './Divider.svelte'
  import Icon from './Icon.svelte'

  export let steps: Array<{ label: string; completed: boolean }>
  export let hideNumbers: boolean | undefined = undefined
  export let block: boolean | undefined = undefined
  export let mobile: boolean | undefined = undefined

  let resizeObserver: ResizeObserver
  let stepper: HTMLDivElement
  let cutOff: number | undefined = undefined

  $: activeIndex = steps.findIndex((step) => !step.completed)

  onMount(() => {
    resizeObserver = new ResizeObserver((entries) => {
      const entry = entries[0]

      if (
        entry &&
        (!cutOff ||
          (mobile ? cutOff < window.innerWidth : cutOff > window.innerWidth))
      ) {
        mobile = stepper.scrollWidth > stepper.clientWidth

        if (mobile) {
          cutOff = window.innerWidth
        }
      }
    })

    resizeObserver.observe(stepper)

    return () => {
      resizeObserver.disconnect()
    }
  })
</script>

<div role="status" class="container" class:block bind:this={stepper}>
  {#each steps as step, index (index)}
    <div class="step" class:active={index === activeIndex}>
      {#if step.completed}
        <Icon icon="ph-check-circle-fill" color="success" />
      {:else if !hideNumbers}
        <div class="number">{index + 1}</div>
      {/if}
      {#if !mobile}
        <div class="label">{step.label}</div>
      {/if}
    </div>
    {#if index < steps.length - 1}
      <Divider />
    {/if}
  {/each}
</div>

<style lang="scss">
  .container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 1em 0;
    width: calc(100% - 2em);
    max-width: 800px;

    &.block {
      width: 100%;
      max-width: unset;
    }

    .step {
      display: flex;
      align-items: center;
      gap: 0.5em;
      margin: 0 0.5em;
      opacity: 0.6;

      &:first-child {
        margin-left: 0;
      }

      &:last-child {
        margin-right: 0;
      }

      &.active {
        opacity: 1;
        font-weight: 500;
      }

      .number {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 12px;
        height: 24px;
        width: 24px;
        border-radius: 50%;
        background-color: var(--color-tertiary);
        color: var(--color-on-tertiary);
      }

      .label {
        width: max-content;
      }
    }
  }
</style>
